import { SYSTEM_FOLDER_PATHS } from '../constants/SystemFolders';
const getIsSystemFolder = folder => {
  return SYSTEM_FOLDER_PATHS.includes(folder.get('full_path'));
};
export default getIsSystemFolder;